export const openaiConfig = {
    endpoint: "https://cae-res.cognitiveservices.azure.com",
    deploymentName: "gpt-5.4",
    apiVersion: "2025-01-01-preview"
};